import React from 'react';
import { StyledButton, StyledOutlinedButton } from './styled.button';
import { IButton } from '../../../@types/button';

export function Button ({
  title,
  onClick,
  outlined,
  backgroundColor,
  inverted,
  height,
  disabled,
}: IButton) {
  if (outlined) {
    return (
      <StyledOutlinedButton
        onClick={onClick}
        inverted={inverted}
        backgroundColor={backgroundColor}
        height={height}
        disabled={disabled}
      >
        {title}
      </StyledOutlinedButton>
    );
  }

  return (
    <StyledButton
      onClick={onClick}
      backgroundColor={backgroundColor}
      height={height}
      disabled={disabled}
    >
      {title}
    </StyledButton>
  );
}
